export default __webpack_public_path__ + "static/rocket-a1bf715b75259672f97e1c2c4cb0e183.mp4";